export function preOrderDetailsBuilderUI(details) {
  return {
    ...details
  };
}

export function preOrderStepBuilderUI(details) {
  return {
    ...details
  };
}
